<template>
  <v-layout row wrap >
    <!-- Dialog -->
    <v-dialog v-model="json_data.status" fullscreen transition="dialog-bottom-transition" :overlay="false">
      <v-card style="background-color:#EEEEEE;">
        <v-toolbar dark color="primary">
          <v-tooltip bottom>
            <v-btn slot="activator" icon dark @click="closeDialog">
              <v-icon>close</v-icon>
            </v-btn>
            <span>{{ $t('close') }}</span>
          </v-tooltip>
          <v-toolbar-title>{{ json_data.save_type == 'create' ? $t('menu.WorkPlanCreate') : $t('menu.WorkPlanEdit') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat dark @click="json_data.save_type == 'create' ? onSave() : onUpdate()">
            <v-icon>save</v-icon>
            <span class="px-2">{{ json_data.save_type == 'create' ? $t('create') : $t('save') }}</span>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container background fluid pa-4>
            <v-layout row wrap pa-4 style="background-color:#fff; margin-top:5px; border-radius:5px;">
              <v-flex md12 sm12 xs12>
                <v-form ref="form" v-model="form_valid">
                  <v-layout row wrap>
                    <v-flex md3 sm3 xs12 pa-3>
                      <v-text-field :label="$t('code')" :readonly="json_data.save_type != 'create'" v-model="form_model.code" :rules="form_rules.code" required append-icon="fas fa-plus-circle"
                        hide-details @click:append="doNewGuid" />
                    </v-flex>
                    <v-flex md3 sm3 xs12 pa-3>
                      <v-text-field :label="$t('name')" v-model="form_model.name" required :rules="form_rules.name" hide-details />
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap >
                    <v-flex md12 sm12 xs12 my-2>
                      <h3>{{$t('menu.WorkPlanList')}}</h3>
                      <v-layout row wrap px-1 py-2 >
                        <v-radio-group  v-model="form_model.plan_type" style="t">
                          <!-- แผนตามเวลา -->
                          <v-flex lg12 md12 sm12 xs12 pa-3>
                            <v-radio :label="$t('Timeplan')" value="0" hide-details />
                            <v-layout lg12 md12 sm12 xs12 pa-3 row wrap  form_model.working_times>
                              <v-flex lg2 md2 sm2 xs3 pa-3>
                                <v-text-field v-model="form_model.start_time_1" label="ช่วงที่ 1 เข้า" type="time"
                                  hide-details />
                              </v-flex>
                              <v-flex lg2 md2 sm2 xs3 pa-3>
                                <v-text-field v-model="form_model.end_time_1" :label="$t('Out')" type="time" hide-details />
                              </v-flex>
                              <v-flex lg2 md2 sm2 xs3 pa-3>
                                <v-text-field v-model="form_model.start_time_2" label="ช่วงที่ 2 เข้า" type="time"
                                  hide-details />
                              </v-flex>
                              <v-flex lg2 md2 sm2 xs3 pa-3>
                                <v-text-field v-model="form_model.end_time_2" :label="$t('Out')" type="time" hide-details />
                              </v-flex>
                              
                              <!-- <v-flex lg2 md2 sm2 xs3 pa-3>
                                <v-text-field v-model="form_model.start_time_3" label="ช่วงที่ 3 เข้า" type="time"
                                  hide-details />
                              </v-flex>
                              <v-flex lg2 md2 sm2 xs3 pa-3>
                                <v-text-field v-model="form_model.end_time_3" :label="$t('Out')" type="time" hide-details />
                              </v-flex> -->
                              <v-flex lg2 md2 sm2 xs3 pa-3>
                                <v-text-field v-model="form_model.working_hours" label="เวลาทำงาน(ชม.)" type="number"
                                  hide-details :min="0" @change="form_model.working_hours = Math.max(Math.abs(form_model.working_hours),0)"/>
                              </v-flex>
                              <v-flex lg2 md2 sm2 xs3 pa-3>
                                <v-text-field v-model="form_model.break_hour" label="เวลาพัก(ชม.)" type="number"
                                  hide-details :min="0" @change="form_model.break_hour = Math.max(Math.abs(form_model.break_hour),0)" />
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <!-- แผนตามวัน -->
                          <v-flex lg12 md12 sm12 xs12 pa-3>
                            <v-radio :label="$t('Plan_by_day')" value="1" hide-details />
                            <div>
                              <v-layout lg12 md12 sm12 xs12 pa-3 row wrap >
                                <v-flex lg2 md2 sm12 xs12 pa-3>
                                  <v-checkbox v-model="form_model.monday" label="จันทร์" value="1" hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.monday_start_time1" label="ช่วงที่ 1 เข้า" type="time"
                                    hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.monday_end_time1" :label="$t('Out')" type="time"
                                    hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.monday_start_time2" label="ช่วงที่ 2 เข้า" type="time"
                                    hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.monday_end_time2" :label="$t('Out')" type="time"
                                    hide-details />
                                </v-flex>
                                <!-- <v-flex lg2 md2 sm2 xs3 pa-3>
                                  <v-text-field v-model="form_model.monday_start_time3" label="ช่วงที่ 3 เข้า" type="time"
                                    hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs3 offset-lg2 offset-md0 offset-sm2 pa-3>
                                  <v-text-field v-model="form_model.monday_end_time3" :label="$t('Out')" type="time"
                                    hide-details />
                                </v-flex> -->
                                <v-flex offset-lg2 offset-md2 lg2 md3 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.monday_work_hour" label="เวลาทำงาน(ชม.)" type="number"
                                    hide-details :min="0" @change="form_model.monday_work_hour = Math.max(Math.abs(form_model.monday_work_hour),0)" />
                                </v-flex>
                                <v-flex lg2 md3 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.monday_break_time" label="เวลาพัก(ชม.)" type="number"
                                    hide-details :min="0" @change="form_model.monday_break_time = Math.max(Math.abs(form_model.monday_break_time),0)" />
                                </v-flex>
                              </v-layout>
                              <v-layout lg12 md12 sm12 xs12 pa-3 row wrap >
                                <v-flex lg2 md2 sm12 xs12 pa-3 >
                                  <v-checkbox v-model="form_model.tuesday" label="อังคาร" value="1" hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.tuesday_start_time1" label="ช่วงที่ 1 เข้า" type="time"
                                    hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.tuesday_end_time1" :label="$t('Out')" type="time"
                                    hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.tuesday_start_time2" label="ช่วงที่ 2 เข้า" type="time"
                                    hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.tuesday_end_time2" :label="$t('Out')" type="time"
                                    hide-details />
                                </v-flex>
                                <!-- <v-flex lg2 md2 sm2 xs3 pa-3>
                                  <v-text-field v-model="form_model.tuesday_start_time3" label="ช่วงที่ 3 เข้า" type="time"
                                    hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs3 offset-lg2 offset-md0 offset-sm2 pa-3>
                                  <v-text-field v-model="form_model.tuesday_end_time3" :label="$t('Out')" type="time"
                                    hide-details />
                                </v-flex> -->
                                <v-flex offset-lg2 offset-md2 lg2 md3 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.tuesday_work_hour" label="เวลาทำงาน(ชม.)" type="number"
                                    hide-details :min="0" @change="form_model.tuesday_work_hour = Math.max(Math.abs(form_model.tuesday_work_hour),0)"/>
                                </v-flex>
                                <v-flex lg2 md3 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.tuesday_break_time" label="เวลาพัก(ชม.)" type="number"
                                    hide-details :min="0" @change="form_model.tuesday_break_time = Math.max(Math.abs(form_model.tuesday_break_time),0)" />
                                </v-flex>
                              </v-layout>
                              <v-layout lg12 md12 sm12 xs12 pa-3 row wrap>
                                <v-flex lg2 md2 sm12 xs12 pa-3>
                                  <v-checkbox v-model="form_model.wednesday" label="พุธ" value="1" hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.wednesday_start_time1" label="ช่วงที่ 1 เข้า" type="time"
                                    hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.wednesday_end_time1" :label="$t('Out')" type="time"
                                    hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.wednesday_start_time2" label="ช่วงที่ 2 เข้า" type="time"
                                    hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.wednesday_end_time2" :label="$t('Out')" type="time"
                                    hide-details />
                                </v-flex>
                                <!-- <v-flex lg2 md2 sm2 xs3 pa-3>
                                  <v-text-field v-model="form_model.wednesday_start_time3" label="ช่วงที่ 3 เข้า" type="time"
                                    hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs3 offset-lg2 offset-md0 offset-sm2 pa-3>
                                  <v-text-field v-model="form_model.wednesday_end_time3" :label="$t('Out')" type="time"
                                    hide-details />
                                </v-flex> -->
                                <v-flex offset-lg2 offset-md2 lg2 md3 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.wednesday_work_hour" label="เวลาทำงาน(ชม.)" type="number"
                                    hide-details :min="0" @change="form_model.wednesday_work_hour = Math.max(Math.abs(form_model.wednesday_work_hour),0)" />
                                </v-flex>
                                <v-flex lg2 md3 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.wednesday_break_time" label="เวลาพัก(ชม.)" type="number"
                                    hide-details :min="0" @change="form_model.wednesday_break_time = Math.max(Math.abs(form_model.wednesday_break_time),0)"/>
                                </v-flex>
                              </v-layout>
                              <v-layout lg12 md12 sm12 xs12 pa-3 row wrap>
                                <v-flex lg2 md2 sm12 xs12 pa-3>
                                  <v-checkbox v-model="form_model.thursday" label="พฤหัสบดี" value="1" hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.thursday_start_time1" label="ช่วงที่ 1 เข้า" type="time"
                                    hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.thursday_end_time1" :label="$t('Out')" type="time"
                                    hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.thursday_start_time2" label="ช่วงที่ 2 เข้า" type="time"
                                    hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.thursday_end_time2" :label="$t('Out')" type="time"
                                    hide-details />
                                </v-flex>
                                <!-- <v-flex lg2 md2 sm2 xs3 pa-3>
                                  <v-text-field v-model="form_model.thursday_start_time3" label="ช่วงที่ 3 เข้า" type="time"
                                    hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs3 offset-lg2 offset-md0 offset-sm2 pa-3>
                                  <v-text-field v-model="form_model.thursday_end_time3" :label="$t('Out')" type="time"
                                    hide-details />
                                </v-flex> -->
                                <v-flex offset-lg2 offset-md2 lg2 md3 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.thursday_work_hour" label="เวลาทำงาน(ชม.)" type="number"
                                    hide-details :min="0" @change="form_model.thursday_work_hour = Math.max(Math.abs(form_model.thursday_work_hour),0)"/>
                                </v-flex>
                                <v-flex lg2 md3 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.thursday_break_time" label="เวลาพัก(ชม.)" type="number"
                                    hide-details :min="0" @change="form_model.thursday_break_time = Math.max(Math.abs(form_model.thursday_break_time),0)"/>
                                </v-flex>
                              </v-layout>
                              <v-layout lg12 md12 sm12 xs12 pa-3 row wrap >
                                <v-flex lg2 md2 sm12 xs12 pa-3>
                                  <v-checkbox v-model="form_model.friday" label="ศุกร์" value="1" hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.friday_start_time1" label="ช่วงที่ 1 เข้า" type="time"
                                    hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.friday_end_time1" :label="$t('Out')" type="time"
                                    hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.friday_start_time2" label="ช่วงที่ 2 เข้า" type="time"
                                    hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.friday_end_time2" :label="$t('Out')" type="time"
                                    hide-details />
                                </v-flex>
                                <!-- <v-flex lg2 md2 sm2 xs3 pa-3>
                                  <v-text-field v-model="form_model.friday_start_time3" label="ช่วงที่ 3 เข้า" type="time"
                                    hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs3 offset-lg2 offset-md0 offset-sm2 pa-3>
                                  <v-text-field v-model="form_model.friday_end_time3" :label="$t('Out')" type="time"
                                    hide-details />
                                </v-flex> -->
                                <v-flex offset-lg2 offset-md2 lg2 md3 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.friday_work_hour" label="เวลาทำงาน(ชม.)" type="number"
                                    hide-details :min="0" @change="form_model.friday_work_hour = Math.max(Math.abs(form_model.friday_work_hour),0)"/>
                                </v-flex>
                                <v-flex lg2 md3 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.friday_break_time" label="เวลาพัก(ชม.)" type="number"
                                    hide-details :min="0" @change="form_model.friday_break_time = Math.max(Math.abs(form_model.friday_break_time),0)"/>
                                </v-flex>
                              </v-layout>
                              <v-layout lg12 md12 sm12 xs12 pa-3 row wrap>
                                <v-flex lg2 md2 sm12 xs12 pa-3>
                                  <v-checkbox v-model="form_model.saturday" label="เสาร์" value="1" hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.saturday_start_time1" label="ช่วงที่ 1 เข้า" type="time"
                                    hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.saturday_end_time1" :label="$t('Out')" type="time"
                                    hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.saturday_start_time2" label="ช่วงที่ 2 เข้า" type="time"
                                    hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.saturday_end_time2" :label="$t('Out')" type="time"
                                    hide-details />
                                </v-flex>
                                <!-- <v-flex lg2 md2 sm2 xs3 pa-3>
                                  <v-text-field v-model="form_model.saturday_start_time3" label="ช่วงที่ 3 เข้า" type="time"
                                    hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs3 offset-lg2 offset-md0 offset-sm2 pa-3>
                                  <v-text-field v-model="form_model.saturday_end_time3" :label="$t('Out')" type="time"
                                    hide-details />
                                </v-flex> -->
                                <v-flex offset-lg2 offset-md2 lg2 md3 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.saturday_work_hour" label="เวลาทำงาน(ชม.)" type="number"
                                    hide-details :min="0" @change="form_model.saturday_work_hour = Math.max(Math.abs(form_model.saturday_work_hour),0)" />
                                </v-flex>
                                <v-flex lg2 md3 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.saturday_break_time" label="เวลาพัก(ชม.)" type="number"
                                    hide-details :min="0" @change="form_model.saturday_break_time = Math.max(Math.abs(form_model.saturday_break_time),0)" />
                                </v-flex>
                              </v-layout>
                              <v-layout lg12 md12 sm12 xs12 pa-3 row wrap >
                                <v-flex lg2 md2 sm12 xs12 pa-3>
                                  <v-checkbox v-model="form_model.sunday" label="อาทิตย์" value="1" hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.sunday_start_time1" label="ช่วงที่ 1 เข้า" type="time"
                                    hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.sunday_end_time1" :label="$t('Out')" type="time"
                                    hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.sunday_start_time2" label="ช่วงที่ 2 เข้า" type="time"
                                    hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.sunday_end_time2" :label="$t('Out')" type="time"
                                    hide-details />
                                </v-flex>
                                <!-- <v-flex lg2 md2 sm2 xs3 pa-3>
                                  <v-text-field v-model="form_model.sunday_start_time3" label="ช่วงที่ 3 เข้า" type="time"
                                    hide-details />
                                </v-flex>
                                <v-flex lg2 md2 sm2 xs3  offset-lg2 offset-md0 offset-sm2 pa-3>
                                  <v-text-field v-model="form_model.sunday_end_time3" :label="$t('Out')"  type="time"
                                    hide-details />
                                </v-flex> -->
                                <v-flex offset-lg2 offset-md2 lg2 md3 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.sunday_work_hour" label="เวลาทำงาน(ชม.)" type="number"
                                    hide-details :min="0" @change="form_model.sunday_work_hour = Math.max(Math.abs(form_model.sunday_work_hour),0)" />
                                </v-flex>
                                <v-flex lg2 md3 sm2 xs6 pa-3>
                                  <v-text-field v-model="form_model.sunday_break_time" label="เวลาพัก(ชม.)" type="number"
                                    hide-details :min="0" @change="form_model.sunday_break_time = Math.max(Math.abs(form_model.sunday_break_time),0)" />
                                </v-flex>
                              </v-layout>
                            </div>
                          </v-flex>
                        </v-radio-group>
                        <!-- หมายเหตุ -->
                        <v-flex lg12 md12 sm12 xs12 pa-3>
                          <v-textarea :label="$t('remark')" hide-details />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap>
            <v-flex xs12 text-xs-right pa-3>
              <v-btn color="success" @click="json_data.save_type == 'create' ? onSave() : onUpdate()">
                <v-icon>save</v-icon>
                <span class="px-2">{{ json_data.save_type == 'create' ? $t('create') : $t('save') }}</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Snackbar -->
    <v-snackbar v-model="snack_model.status" :timeout="3500" :top="'top'" :color="snack_model.type">
      {{ snack_model.msg }}
      <v-btn dark flat icon @click="snack_model.status = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>
<script>
  /* eslint-disable */
  import {
    mapActions
  } from "vuex";
  import SettingService from "@/services/SettingService";
  import Utils from "@/utils/";

  export default {
    props: {
      json_data: Object
    },
    watch: {
      json_data(val) {
        if (val.data != null) {
          this.form_model = val.data;
          this.form_model.monday = val.data.monday + "";
          this.form_model.tuesday = val.data.tuesday + "";
          this.form_model.wednesday = val.data.wednesday + "";
          this.form_model.thursday = val.data.thursday + "";
          this.form_model.friday = val.data.friday + "";
          this.form_model.saturday = val.data.saturday + "";
          this.form_model.sunday = val.data.sunday + "";
        } else {
          this.$refs.form.resetValidation();
          this.doNewGuid();
        }
      }
    },
    data: () => ({
      form_valid: false,
      form_model: {
        code: "",
        name: "",
        remark: "",
        plan_type: "0",
        start_time_1: "",
        end_time_1: "",
        start_time_2: "",
        end_time_2: "",
        start_time_3: "",
        end_time_3: "",
        working_hours: 0,
        break_hour: 0,
        monday: "0",
        monday_start_time1: "",
        monday_end_time1: "",
        monday_start_time2: "",
        monday_end_time2: "",
        monday_start_time3: "",
        monday_end_time3: "",
        monday_work_hour: 0,
        monday_break_time: 0,
        tuesday: "0",
        tuesday_start_time1: "",
        tuesday_end_time1: "",
        tuesday_start_time2: "",
        tuesday_end_time2: "",
        tuesday_start_time3: "",
        tuesday_end_time3: "",
        tuesday_work_hour: 0,
        tuesday_break_time: 0,
        wednesday: "0",
        wednesday_start_time1: "",
        wednesday_end_time1: "",
        wednesday_start_time2: "",
        wednesday_end_time2: "",
        wednesday_start_time3: "",
        wednesday_end_time3: "",
        wednesday_work_hour: 0,
        wednesday_break_time: 0,
        thursday: "0",
        thursday_start_time1: "",
        thursday_end_time1: "",
        thursday_start_time2: "",
        thursday_end_time2: "",
        thursday_start_time3: "",
        thursday_end_time3: "",
        thursday_work_hour: 0,
        thursday_break_time: 0,
        friday: "0",
        friday_start_time1: "",
        friday_end_time1: "",
        friday_start_time2: "",
        friday_end_time2: "",
        friday_start_time3: "",
        friday_end_time3: "",
        friday_work_hour: 0,
        friday_break_time: 0,
        saturday: "0",
        saturday_start_time1: "",
        saturday_end_time1: "",
        saturday_start_time2: "",
        saturday_end_time2: "",
        saturday_start_time3: "",
        saturday_end_time3: "",
        saturday_work_hour: 0,
        saturday_break_time: 0,
        sunday: "0",
        sunday_start_time1: "",
        sunday_end_time1: "",
        sunday_start_time2: "",
        sunday_end_time2: "",
        sunday_start_time3: "",
        sunday_end_time3: "",
        sunday_work_hour: 0,
        sunday_break_time: 0,
        creator_code: localStorage._usercode
      },
      form_rules: {
        code: [v => !!v || "do not empty."],
        name: [v => !!v || "do not empty."]
      },
      snack_model: {
        status: "",
        msg: "",
        type: ""
      }
    }),
    methods: {
      ...mapActions("alert", ["commitToggleAlertDialog"]),
      closeDialog() {
        this.clearForm();
        this.$emit("close-dialog");
      },
      doNewGuid() {
        this.form_model.code = Utils.newGuid('S');
      },
      clearForm() {
        this.form_model = {
          code: "",
          name: "",
          remark: "",
          plan_type: "0",
          start_time_1: "",
          end_time_1: "",
          start_time_2: "",
          end_time_2: "",
          start_time_3: "",
          end_time_3: "",
          working_hours: 0,
          break_hour: 0,
          monday: "0",
          monday_start_time1: "",
          monday_end_time1: "",
          monday_start_time2: "",
          monday_end_time2: "",
          monday_start_time3: "",
          monday_end_time3: "",
          monday_work_hour: 0,
          monday_break_time: 0,
          tuesday: "0",
          tuesday_start_time1: "",
          tuesday_end_time1: "",
          tuesday_start_time2: "",
          tuesday_end_time2: "",
          tuesday_start_time3: "",
          tuesday_end_time3: "",
          tuesday_work_hour: 0,
          tuesday_break_time: 0,
          wednesday: "0",
          wednesday_start_time1: "",
          wednesday_end_time1: "",
          wednesday_start_time2: "",
          wednesday_end_time2: "",
          wednesday_start_time3: "",
          wednesday_end_time3: "",
          wednesday_work_hour: 0,
          wednesday_break_time: 0,
          thursday: "0",
          thursday_start_time1: "",
          thursday_end_time1: "",
          thursday_start_time2: "",
          thursday_end_time2: "",
          thursday_start_time3: "",
          thursday_end_time3: "",
          thursday_work_hour: 0,
          thursday_break_time: 0,
          friday: "0",
          friday_start_time1: "",
          friday_end_time1: "",
          friday_start_time2: "",
          friday_end_time2: "",
          friday_start_time3: "",
          friday_end_time3: "",
          friday_work_hour: 0,
          friday_break_time: 0,
          saturday: "0",
          saturday_start_time1: "",
          saturday_end_time1: "",
          saturday_start_time2: "",
          saturday_end_time2: "",
          saturday_start_time3: "",
          saturday_end_time3: "",
          saturday_work_hour: 0,
          saturday_break_time: 0,
          sunday: "0",
          sunday_start_time1: "",
          sunday_end_time1: "",
          sunday_start_time2: "",
          sunday_end_time2: "",
          sunday_start_time3: "",
          sunday_end_time3: "",
          sunday_work_hour: 0,
          sunday_break_time: 0,
          creator_code: localStorage._usercode
        };
      },
      showSnackBar(msg, type) {
        this.snack_model.msg = msg;
        this.snack_model.type = type;
        this.snack_model.status = true;
      },
      onSave() {
        if (this.form_valid) {
          if (this.form_model.plan_type == "1") {
            if (
              this.form_model.monday == "1" &&
              (this.form_model.monday_start_time1 == "" ||
                this.form_model.monday_start_time1 == null) &&
              (this.form_model.monday_end_time1 == "" ||
                this.form_model.monday_end_time1 == null)
            ) {
              this.showSnackBar('กรุณาเพิ่มช่วงเวลาทำงานใน วันจันทร์', 'error');
              return;
            }
            if (
              this.form_model.tuesday == "1" &&
              (this.form_model.tuesday_start_time1 == "" ||
                this.form_model.tuesday_start_time1 == null) &&
              (this.form_model.tuesday_end_time1 == "" ||
                this.form_model.tuesday_end_time1 == null)
            ) {
              this.showSnackBar('กรุณาเพิ่มช่วงเวลาทำงานใน วันอังคาร', 'error');
              return;
            }
            if (
              this.form_model.wednesday == "1" &&
              (this.form_model.wednesday_start_time1 == "" ||
                this.form_model.wednesday_start_time1 == null) &&
              (this.form_model.wednesday_end_time1 == "" ||
                this.form_model.wednesday_end_time1 == null)
            ) {
              this.showSnackBar('กรุณาเพิ่มช่วงเวลาทำงานใน วันพุธ', 'error');

              return;
            }
            if (
              this.form_model.thursday == "1" &&
              (this.form_model.thursday_start_time1 == "" ||
                this.form_model.thursday_start_time1 == null) &&
              (this.form_model.thursday_end_time1 == "" ||
                this.form_model.thursday_end_time1 == null)
            ) {
              this.showSnackBar('กรุณาเพิ่มช่วงเวลาทำงานใน วันพฤหัส', 'error');

              return;
            }
            if (
              this.form_model.friday == "1" &&
              (this.form_model.friday_start_time1 == "" ||
                this.form_model.friday_start_time1 == null) &&
              (this.form_model.friday_end_time1 == "" ||
                this.form_model.friday_end_time1 == null)
            ) {
              this.showSnackBar('กรุณาเพิ่มช่วงเวลาทำงานใน วันศุกร์', 'error');
              return;
            }
            if (
              this.form_model.saturday == "1" &&
              (this.form_model.saturday_start_time1 == "" ||
                this.form_model.saturday_start_time1 == null) &&
              (this.form_model.saturday_end_time1 == "" ||
                this.form_model.saturday_end_time1 == null)
            ) {
              this.showSnackBar('กรุณาเพิ่มช่วงเวลาทำงานใน วันเสาร์', 'error');
              return;
            }
            if (
              this.form_model.sunday == "1" &&
              (this.form_model.sunday_start_time1 == "" ||
                this.form_model.sunday_start_time1 == null) &&
              (this.form_model.sunday_end_time1 == "" ||
                this.form_model.sunday_end_time1 == null)
            ) {
              this.showSnackBar('กรุณาเพิ่มช่วงเวลาทำงานใน วันอาทิตย์', 'error');
              return;
            }
          } else {
            if (
              (this.form_model.start_time_1 == "" ||
                this.form_model.start_time_1 == null) &&
              (this.form_model.end_time_1 == "" ||
                this.form_model.end_time_1 == null)
            ) {
              this.showSnackBar('กรุณาเพิ่มช่วงเวลาทำงาน', 'error');
              return;
            }
          }
          SettingService.createProfilePlan(this.form_model)
            .then(res => {
              this.showSnackBar('save success', 'success');
              this.closeDialog();
            })
            .catch(err => {
              this.showSnackBar(err.response.data, 'error');
            });
        } else {
          this.$refs.form.validate();
        }
      },
      onUpdate() {
        if (this.form_valid) {
          if (this.form_model.plan_type == "1") {
            if (
              this.form_model.monday == "1" &&
              (this.form_model.monday_start_time1 == "" ||
                this.form_model.monday_start_time1 == null) &&
              (this.form_model.monday_end_time1 == "" ||
                this.form_model.monday_end_time1 == null)
            ) {
              this.showSnackBar('กรุณาเพิ่มช่วงเวลาทำงานใน วันจันทร์', 'error');
              return;
            }
            if (
              this.form_model.tuesday == "1" &&
              (this.form_model.tuesday_start_time1 == "" ||
                this.form_model.tuesday_start_time1 == null) &&
              (this.form_model.tuesday_end_time1 == "" ||
                this.form_model.tuesday_end_time1 == null)
            ) {
              this.showSnackBar('กรุณาเพิ่มช่วงเวลาทำงานใน วันอังคาร', 'error');
              return;
            }
            if (
              this.form_model.wednesday == "1" &&
              (this.form_model.wednesday_start_time1 == "" ||
                this.form_model.wednesday_start_time1 == null) &&
              (this.form_model.wednesday_end_time1 == "" ||
                this.form_model.wednesday_end_time1 == null)
            ) {
              this.showSnackBar('กรุณาเพิ่มช่วงเวลาทำงานใน วันพุธ', 'error');

              return;
            }
            if (
              this.form_model.thursday == "1" &&
              (this.form_model.thursday_start_time1 == "" ||
                this.form_model.thursday_start_time1 == null) &&
              (this.form_model.thursday_end_time1 == "" ||
                this.form_model.thursday_end_time1 == null)
            ) {
              this.showSnackBar('กรุณาเพิ่มช่วงเวลาทำงานใน วันพฤหัส', 'error');

              return;
            }
            if (
              this.form_model.friday == "1" &&
              (this.form_model.friday_start_time1 == "" ||
                this.form_model.friday_start_time1 == null) &&
              (this.form_model.friday_end_time1 == "" ||
                this.form_model.friday_end_time1 == null)
            ) {
              this.showSnackBar('กรุณาเพิ่มช่วงเวลาทำงานใน วันศุกร์', 'error');
              return;
            }
            if (
              this.form_model.saturday == "1" &&
              (this.form_model.saturday_start_time1 == "" ||
                this.form_model.saturday_start_time1 == null) &&
              (this.form_model.saturday_end_time1 == "" ||
                this.form_model.saturday_end_time1 == null)
            ) {
              this.showSnackBar('กรุณาเพิ่มช่วงเวลาทำงานใน วันเสาร์', 'error');
              return;
            }
            if (
              this.form_model.sunday == "1" &&
              (this.form_model.sunday_start_time1 == "" ||
                this.form_model.sunday_start_time1 == null) &&
              (this.form_model.sunday_end_time1 == "" ||
                this.form_model.sunday_end_time1 == null)
            ) {
              this.showSnackBar('กรุณาเพิ่มช่วงเวลาทำงานใน วันอาทิตย์', 'error');
              return;
            }
          } else {
            if (
              (this.form_model.start_time_1 == "" ||
                this.form_model.start_time_1 == null) &&
              (this.form_model.end_time_1 == "" ||
                this.form_model.end_time_1 == null)
            ) {
              this.showSnackBar('กรุณาเพิ่มช่วงเวลาทำงาน', 'error');
              return;
            }
          }
          this.form_model.creator_code = localStorage._usercode;
          SettingService.updateProfilePlan(this.form_model)
            .then(res => {
              this.showSnackBar('update success', 'success');
              this.closeDialog();
            })
            .catch(err => {
              this.showSnackBar(err.response.data, 'error');
            });
        } else {
          this.$refs.form.validate();
        }
      }
    }
  };
</script>
<style>
  .v-input--selection-controls {
    margin-top: 0;
  }

  .v-text-field {
    padding-top: 6;
    margin-top: 0;
  }
  .v-card__text{
    padding:0px !important;
  }
</style>